import React from 'react';
import PropTypes from 'prop-types';
import Alert from '@material-ui/lab/Alert';
import Button from '@material-ui/core/Button';

// Bandeau d'un enregistrement refusé par le contrôle de modification
// (plan 070b, Q19). Il reste affiché jusqu'au rechargement de la fiche.
//
// `width: 0` + `minWidth: '100%'` : le bandeau prend la largeur du tiroir sans
// l'élargir (le tiroir se dimensionne sur son contenu).
const bannerStyle = {
  width: 0,
  minWidth: '100%',
  boxSizing: 'border-box',
  marginBottom: 8,
};

const ConflictBanner = ({ error, onReload }) => {
  if (!error) {
    return null;
  }

  return (
    <Alert severity="warning" style={bannerStyle}>
      <div>{error.message}</div>
      <div style={{ marginTop: 4 }}>
        Vos saisies non enregistrées seront perdues au rechargement : copiez-les
        avant si besoin.
      </div>
      <Button
        color="inherit"
        size="small"
        variant="outlined"
        onClick={onReload}
        style={{ marginTop: 8 }}
      >
        Recharger la fiche
      </Button>
    </Alert>
  );
};

ConflictBanner.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  error: PropTypes.object,
  onReload: PropTypes.func,
};

ConflictBanner.defaultProps = {
  error: null,
  onReload: /* istanbul ignore next */ () => {},
};

export default ConflictBanner;
